<!-- LazyComponent.vue -->
<template>
  <div
      ref="container"
      class="lazy-component"
      :style="placeholderStyle"
  >
    <!-- 已渲染的内容 -->
    <component
        v-if="isVisible && component"
        :is="component"
        v-bind="props"
        v-on="$listeners"
    />

    <!-- 占位内容 -->
    <div v-else class="lazy-placeholder">
      <slot name="placeholder">
        <div class="default-placeholder">
          <!-- 骨架屏或加载动画 -->
          <div class="skeleton"></div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LazyComponent',

  props: {
    component: {
      type: [Object, Function, String],
      required: true
    },
    props: {
      type: Object,
      default: () => ({})
    },
    threshold: {
      type: Number,
      default: 0.1
    },
    rootMargin: {
      type: String,
      default: '50px 0px'
    },
    minHeight: {
      type: String,
      default: '200px'
    }
  },

  data() {
    return {
      isVisible: false,
      observer: null
    };
  },

  computed: {
    placeholderStyle() {
      return {
        minHeight: this.minHeight
      };
    }
  },

  mounted() {
    this.initObserver();
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },

  methods: {
    initObserver() {
      // 检查是否支持 Intersection Observer
      if (!('IntersectionObserver' in window)) {
        // 不支持则立即渲染
        this.isVisible = true;
        return;
      }

      this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.isVisible = true;
                this.$emit('visible');

                // 渲染后停止观察
                if (this.observer) {
                  this.observer.disconnect();
                }
              }
            });
          },
          {
            threshold: this.threshold,
            rootMargin: this.rootMargin
          }
      );

      this.observer.observe(this.$refs.container);
    },

    // 手动触发渲染
    forceRender() {
      this.isVisible = true;
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }
};
</script>

<style scoped>
.lazy-component {
  width: 100%;
  position: relative;
}

.lazy-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.default-placeholder {
  width: 100%;
  padding: 20px;
}

.skeleton {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
